export var useSlackChannel = function useSlackChannel(team) {
    var _team_contact;
    var hasSupportChannel = Boolean(team === null || team === void 0 ? void 0 : (_team_contact = team.contact) === null || _team_contact === void 0 ? void 0 : _team_contact.slack);
    if (!team || !hasSupportChannel) {
        return [
            false,
            '',
            ''
        ];
    }
    var channelSlug = team.contact.slack.replace(/^#/, '');
    var channelWithHash = "#".concat(channelSlug);
    var channelLink = "https://coveo.slack.com/app_redirect?channel=".concat(channelSlug);
    return [
        hasSupportChannel,
        channelWithHash,
        channelLink
    ];
};

//# sourceMappingURL=useSlackChannel.js.map